import { useState, useEffect, useRef, useMemo } from "react"
import { useNavigate, useLocation, Link } from "react-router-dom"
import { toast } from 'react-toastify'
import Server from "../../Shared/Server"
import Spinner from '../../Shared/Spinner'

import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';

const LocationMessageHistory = () => {
    const [messages, setMessages] = useState([])
    const [locationData, setLocationData] = useState({})
    const [date, setDate] = useState(new Date().toISOString().slice(0, 10))
    const [isLoading, setIsLoading] = useState(false)
    const [formData, setFormData] = useState({
        public_id: "",
    })
    const {public_id} = formData

    const gridRef = useRef();

    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if (location.state){
            const {data} = location.state
            setFormData((prev) => ({
                ...prev,
                public_id: data.public_id
            }))

            setLocationData(data)
            fetchData(data.public_id)
        }
    }, [])

    const fetchData = async (public_id) => {
        setIsLoading(true)
        try {
            const response = await Server.get(`/locations/message-history?public_id=${public_id}`)
            setMessages(response?.data)
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            if(error?.response?.status === 401){
                localStorage.removeItem('user')
                navigate('/login')
            }else if (error?.response?.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error?.response?.data?.detail || 'Failed to fetch message history')
            }
        }
    }

    const resendMessage = async (payload) => {
        setIsLoading(true);
        try {
            const response = await Server.post(`/messages/resend-message?public_id=${payload.public_id}`, payload)
            toast.success(response.data.detail);
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false);
            if(error?.response?.status === 401){
                localStorage.removeItem('user')
                navigate('/login')
            }else if (error?.response?.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error?.response?.data?.detail || 'Failed to resend message')
            }
        }
    }

    const defaultColDef = useMemo(() => {
        return {
            filterParams: {
                buttons: []
            }
        };
    }, []);

    const columnDefs = useMemo(() => [
        {
            headerName: "#",
            filter: false,
            maxWidth: 70,
            sortable: true,
            valueFormatter: function (params) {
            if (isNaN(params.node.id)) {
                return "";
            }
            return `${Number(params.node.rowIndex) + 1}`;
            },
        },
        {
            headerName: "Date",
            field: "date",
            sortable: true,
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (filterDate, cellValue) => {
                    const cellDate = new Date(cellValue);
                    cellDate.setHours(0, 0, 0, 0);
                    filterDate.setHours(0, 0, 0, 0);

                    if (cellDate < filterDate) return -1;
                    if (cellDate > filterDate) return 1;
                    return 0;
                },
            },
        },
        {
            headerName: "Category",
            field: "category",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Receiver",
            field: "receiver",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Body",
            field: "body",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Status",
            field: "status",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Counter",
            field: "counter",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Actions",
            pinned: 'left',
            minWidth: 100,
            sortable: false,
            filter: false,
            cellRenderer: (e) => {
                if (!e.data) return null;
                return (
                    <div className="d-flex gap-1">
                        <button
                            className='btn btn-outline-info'
                            onClick={() => resendMessage({
                                public_id: e.data.public_id,
                            })}
                            title="Resend Message"
                        >
                            Resend
                        </button>
                    </div>
                );
            },
        }
    ], []);

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="row">
            <div className="col-md-12">
                <Link to='/send-single-message' state={{payload: {public_id}}} className="btn btn-outline-info mb-2" style={{float: 'right'}}>New Message</Link>
            </div>
        </div>
        <div className="card">
        <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
            <h3 className="card-title">{locationData?.customer?.full_name} Message History as {date}</h3>
        </div>
        <div className="card-body">
            <div className="row">
                <div className="col-md-12">
                    <div className="ag-theme-alpine responsive-aggrid" style={{ height: 400, width: '100%' }}>
                    <AgGridReact
                        suppressMenuHide={true}
                        defaultColDef={defaultColDef}

                        rowData={messages}
                        domLayout={"normal"}
                        rowSelection={"multiple"}

                        animateRows={true}

                        pagination={false}

                        resizable={true}
                        enableCellTextSelection={true}
                        suppressCellFocus={true}


                    ref={gridRef}
                        groupIncludeTotalFooter={false}
                        groupIncludeFooter={false}
                        columnDefs={columnDefs}
                    ></AgGridReact>{" "}
                </div>
                </div>
            </div>
        </div>
        </div>
      <br/>
    </>
  )
}

export default LocationMessageHistory